import React from "react";
import { QRCodeSVG } from "qrcode.react";

const DEFAULT_SIZE = 112;

/**
 * Shows a QR encoding downloadHref when available (same URL as the download button).
 * Falls back to API-provided QR image, then placeholder.
 */
export default function ApkDownloadQrDisplay({
  downloadHref,
  apiQrUrl,
  placeholderSrc = "/images/scan.png",
  size = DEFAULT_SIZE,
}) {
  // console.log("🚀 ~ ApkDownloadQrDisplay ~ placeholderSrc:", placeholderSrc)
  // console.log("🚀 ~ ApkDownloadQrDisplay ~ apiQrUrl:", apiQrUrl)
  // console.log("🚀 ~ ApkDownloadQrDisplay ~ downloadHref:", downloadHref)
  if (downloadHref) {
    return (
      <span className="apk-download-qr-wrap" role="img" aria-label="QR code for app download">
        <QRCodeSVG
          value={downloadHref}
          size={size}
          level="M"
          includeMargin={false}
          bgColor="#ffffff"
          fgColor="#000000"
        />
      </span>
    );
  }

  const src = apiQrUrl || placeholderSrc;
  // console.log("🚀 ~ ApkDownloadQrDisplay ~ src:", src)
  return <img src={src} alt="App download QR" />;
}
